var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouseBlank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "vector",
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M23.045,8.034L13.545,0.566c-0.908,-0.715 -2.182,-0.715 -3.09,0L0.955,8.034c-0.607,0.477 -0.955,1.193 -0.955,1.966v14L24,24L24,10c0,-0.772 -0.348,-1.488 -0.955,-1.966ZM23,23L1,23L1,10c0,-0.464 0.209,-0.894 0.572,-1.179L11.072,1.354c0.547,-0.43 1.309,-0.43 1.855,0l9.5,7.468c0.363,0.285 0.572,0.715 0.572,1.179v13Z",
    id: "path_0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseBlank);
export default __webpack_public_path__ + "static/media/house_blank.9fbab1816f8849ab1a23628839ffad51.svg";
export { ForwardRef as ReactComponent };